// extracted by mini-css-extract-plugin
module.exports = {"collapsibleControl":"CollapsibleControl_collapsibleControl__1jhxr"};